import React from 'react'

export const Controls = ({current, total, loadNextPage, loadPreviousPage}) => {
  if (total <= 1) return null

  return <div className="controls">
    <div className="index">{I18n.t('fundraising_events.opinions.index.carousel_controls_details', {current_page: current, total_pages: total})}</div>
    <div className="btn-group">
      <a className="btn btn-secondary" disabled={current === 1} onClick={current > 1 ? loadPreviousPage : null}>
        <i className="fa fa-caret-left"></i>
      </a>
      <a className="btn btn-secondary" disabled={current === total} onClick={current < total ? loadNextPage : null}>
        <i className="fa fa-caret-right"></i>
      </a>
    </div>
  </div>
}
